import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/**
 * As mutations que fazem as modificações nas variaves do state.
 */
export default {
  setContratoSincronizando: function setContratoSincronizando(state, _ref) {
    var contratoId = _ref.contratoId,
      token = _ref.token;
    if (!contratoId || !token) return;
    state.contratosSincronizando = _objectSpread(_objectSpread({}, state.contratosSincronizando), {}, _defineProperty({}, String(contratoId), token));
  },
  removeContratoSincronizando: function removeContratoSincronizando(state, contratoId) {
    var contratosSincronizando = _objectSpread({}, state.contratosSincronizando);
    delete contratosSincronizando[String(contratoId)];
    state.contratosSincronizando = contratosSincronizando;
  },
  clearContratosSincronizando: function clearContratosSincronizando(state) {
    state.contratosSincronizando = {};
  }
};